import {Component, EventEmitter, Input, Output} from '@angular/core';
import {RestDataService} from '../../../services/rest-data.service';
import {SmallSelectItem} from '../../../services/common-datatypes';
import {RequiredInput} from '../../../decorators/common.decorators';
import {marker as _} from '@biesbjerg/ngx-translate-extract-marker';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-location-status-select',
    templateUrl: './location-status-select.component.html',
    styleUrls: ['./location-status-select.component.scss']
})
export class LocationStatusSelectComponent {

    public selectList: SmallSelectItem[] = [];
    @Input() inline = false;
    @Input() autoOpen = false;
    @Input() multiple = false;
    @Input() allowEmpty = true;
    @Input() hidden: string[] = [];
    @Input() @RequiredInput selectedItems!: SmallSelectItem[];
    @Output() selectedItemsChange = new EventEmitter<SmallSelectItem[]>();

    private allStatus: SmallSelectItem[] = [];

    constructor(private translate: TranslateService,
                private dataService: RestDataService) {
        _('select.location_status.name');
        _('select.location_status.all');
        this.loadData();
    }

    loadData() {
        if (0 === this.selectList.length) {
            this.dataService.getLocationStatus().then((data: SmallSelectItem[]) => {
                if (data && (0 < data.length)) {
                    data.forEach((item) => {
                        if (!this.hidden.includes(item.name)) {
                            const newItem = new SmallSelectItem();
                            newItem.updateFromJson(item);
                            this.translate.get('location_status.' + item.name).subscribe(
                                (trans: string) => newItem.name = trans
                            );
                            this.allStatus.push(newItem);
                            if (!this.hidden.includes(newItem.name)) this.selectList.push(newItem);
                        }
                    });
                }
            });
        } else {
            this.selectList = [];
            this.allStatus.forEach((item) => {
                if (!this.hidden.includes(item.name)) this.selectList.push(item);
            });
        }
    }

    updateData() {
        this.selectedItemsChange.emit(this.selectedItems);
    }
}
